import styles from './MainLayout.module.scss'

import Navbar from 'common/components/Navbar/Navbar'
import NavTabs from 'common/components/NavTabs/NavTabs'
import Footer from 'common/components/Footer'
import SupportButton from 'common/components/SupportButton/SupportButton'

/**
 * Layout for the logged-in pages: the top bar and the tab row, then the page
 * content, then the footer.
 *
 * @param {{ children: import('react').ReactNode }} props
 */
const MainLayout = props => {
  return (
    <div className={styles.component}>
      <div className={styles.stickyHeader}>
        <Navbar />
        <NavTabs />
      </div>
      <div className={styles.content}>
        {props.children}
        <SupportButton />
      </div>
      <Footer isLoggedIn />
    </div>
  )
}

export default MainLayout
